/**************************************************
 * Nombre:       Formulario_Producto_Nombre
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, Title} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import { ESTADOSPRODUCTO} from "../../Constantes";
import IngresoTextoEstilo from "../../Modulo_formularios/Componentes/IngresoTextoEstilo";

const Formulario_Adicional = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Title} nombre={'Titulo'} dato={'titulo'} {...props}
                                  requerido={'El titulo es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTextoEstilo Icono={Title} nombre={'Texto'} dato={'textoEstilo'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Adicional